"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var client_1 = require("@apollo/client");
var react_progress_bar_1 = __importDefault(require("@ramonak/react-progress-bar"));
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var Button_1 = __importDefault(require("../../../../common/Button/Button"));
var config_1 = __importDefault(require("../../../../config/config"));
var org_hook_1 = require("../../../../context/OrgContext/org.hook");
var user_hook_1 = require("../../../../context/UserContext/user.hook");
var icons_1 = __importDefault(require("../../../../theme/icons"));
var Queries_1 = require("../../Graphql/Queries");
var DownloadFile = function () {
    var _a, _b, _c, _d;
    var organization = (0, org_hook_1.useOrg)().organization;
    var user = (0, user_hook_1.useUser)().user;
    var _e = (0, react_1.useState)({
        name: "",
        status: "",
        download_link: "#",
        created_at: "",
        updated_at: "",
        percent: 0,
    }), zipStatus = _e[0], setZipStatus = _e[1];
    var t = (0, react_i18next_1.useTranslation)().t;
    var getZip = (user &&
        (0, client_1.useLazyQuery)(Queries_1.GET_DOWNLOAD_FILE, {
            variables: {
                name: "".concat(config_1.default.app_name, " ").concat((_a = user === null || user === void 0 ? void 0 : user.user_info) === null || _a === void 0 ? void 0 : _a.address_country, " ").concat(organization.code)
                    .split(" ")
                    .join("-")
                    .toLowerCase(),
            },
            notifyOnNetworkStatusChange: true,
            fetchPolicy: "network-only",
            onCompleted: function (data) {
                // console.log({ data });
                setZipStatus(data.getZipStatus);
            },
        }))[0];
    var getZipFile = (0, client_1.useLazyQuery)(Queries_1.GET_ZIP, {
        variables: {
            app: (_b = config_1.default.app_name) === null || _b === void 0 ? void 0 : _b.split(" ").join("-").toLowerCase(),
            organization_id: parseInt(organization.id),
        },
        notifyOnNetworkStatusChange: true,
        fetchPolicy: "network-only",
        onError: function () {
            getZip();
        },
        onCompleted: function () {
            getZip();
        },
    })[0];
    (0, react_1.useEffect)(function () {
        getZip();
    }, []);
    var MINUTE_MS = 5000;
    (0, react_1.useEffect)(function () {
        if (zipStatus && (zipStatus === null || zipStatus === void 0 ? void 0 : zipStatus.status) !== "finished") {
            var interval_1 = setInterval(function () {
                getZip();
            }, MINUTE_MS);
            return function () { return clearInterval(interval_1); };
        } // This represents the unmount function, in which you need to clear your interval to prevent memory leaks.
    }, [zipStatus]);
    var sync = function () {
        setZipStatus(__assign(__assign({}, zipStatus), { status: "" }));
        setInterval(function () {
            getZip();
        }, 2000);
        getZipFile();
    };
    return (react_1.default.createElement("div", { className: "download-card" },
        react_1.default.createElement("img", { src: ((_c = zipStatus === null || zipStatus === void 0 ? void 0 : zipStatus.status) === null || _c === void 0 ? void 0 : _c.includes("zipping"))
                ? "/images/zip.svg"
                : ((_d = zipStatus === null || zipStatus === void 0 ? void 0 : zipStatus.status) === null || _d === void 0 ? void 0 : _d.includes("upload"))
                    ? "/images/google.svg"
                    : "/images/download.svg", height: "100px" }),
        (zipStatus === null || zipStatus === void 0 ? void 0 : zipStatus.status) == "finished" ? (react_1.default.createElement("div", { style: { display: "flex", flexDirection: "column" } },
            react_1.default.createElement("p", { className: "updated-at" }, "".concat(t("Created At"), " ").concat(zipStatus === null || zipStatus === void 0 ? void 0 : zipStatus.updated_at)),
            react_1.default.createElement("div", { style: { display: "flex", flexDirection: "row" } },
                react_1.default.createElement(Button_1.default, { className: "button form-buttom", icon: react_1.default.createElement(icons_1.default, { name: "zip", className: "icon", height: 30, width: 30 }), onClick: function () { return sync(); }, style: { width: 150, color: "white", marginRight: 2 }, text: t("Update Zip") }),
                react_1.default.createElement("a", { className: "button form-buttom", style: {
                        width: "150px",
                        color: "white",
                        marginRight: "2px",
                        textDecoration: "none",
                    }, href: "".concat(zipStatus === null || zipStatus === void 0 ? void 0 : zipStatus.download_link) },
                    react_1.default.createElement(icons_1.default, { name: "download", className: "icon", height: 30, width: 30 }),
                    t("Download"))))) : (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: "updated-at" }, zipStatus === null || zipStatus === void 0 ? void 0 : zipStatus.status),
            (zipStatus === null || zipStatus === void 0 ? void 0 : zipStatus.percent) > 0 ? (react_1.default.createElement(react_progress_bar_1.default, { className: "progress", completed: Math.round(zipStatus === null || zipStatus === void 0 ? void 0 : zipStatus.percent), labelAlignment: "center" })) : null,
            react_1.default.createElement("div", { className: "download-notice" },
                " ",
                t("Please wait while uploading. It may take several minutes...."))))));
};
exports.default = DownloadFile;
